module.exports = __webpack_public_path__ + "static/media/V_pictos-06.cc749f1d.svg";